'use strict'

import config from './config';
import tagManager from './tag-manager';

function getValueOrNotSet(value) {
	return value ? value : 'NotSet';
}

function isExternalLink(href) {
	var result = false;

	if (URL.canParse(href)) {
		const currentDomain = new URL(window.location.href).hostname;
		const linkDomain = new URL(href).hostname;

		result = currentDomain !== linkDomain;
	}

	return result;
}

function isAmazonLink(href) {
	return href.startsWith('https://www.amazon.co.uk') || href.startsWith('https://www.amazon.com');
}

function updateLinkParams($link, params) {
	if (!params) {
		return;
	}

	let linkParams = new URLSearchParams($link[0].search);
	Object.keys(params).forEach(key => linkParams.set(key, params[key]));
	$link[0].search = linkParams.toString();

	console.info(`Update href: ${$link.attr('href')}`);
}

function buildAmazonTrackingParams (trackingParams) {
	let result = {};

	if (trackingParams) {
		result = {
			'asc_source': 'paidtraffic',
			'asc_campaign': `${trackingParams.trackingIdName},${trackingParams.trackingId}`,
			'asc_refurl': window.location.href
		};
	}

	if (config.enableCmsAmazonTrackingId) {
		if (!result) {
			result = {
				'tag': config.amazonTrackingId
			};
		} else {
			result['tag'] = config.amazonTrackingId;
		}
	}

	return result;
}

function buildQueryParams(href, trackingParams) {
	if (isAmazonLink(href)) {
		return buildAmazonTrackingParams(trackingParams);
	}

	if (!trackingParams) {
		return;
	}
	
	if (href.startsWith('https://redirect.viglink.com')) {
		return {
			'cuid': `${getValueOrNotSet(trackingParams.utmMedium)}|${getValueOrNotSet(trackingParams.utmSource)}|${trackingParams.trackingIdName},${trackingParams.trackingId}`
		};
	} else {
		return {
			'xcust': `${getValueOrNotSet(trackingParams.utmMedium)}|${getValueOrNotSet(trackingParams.utmSource)}|${trackingParams.trackingIdName},${trackingParams.trackingId}`
		};
	}
}

function updateTrackingLinks(trackingParams) {
	const excludedDomains = [
		'https://images.parkers.bauermedia.group',
		'https://parkers-images.dev.bauersecure.com',
		'https://parkers-images.stg.bauersecure.com',
		'https://parkers-images.bauersecure.com',
		'https://www.parkers.co.uk',
		'mailto'
	];

	var linksToUpdate = $('a').filter(function () {
		const href = $(this).attr('href');
		const isExcluded = excludedDomains.some(prefix => href?.startsWith(prefix));
		const isNavLink = $(this).closest('nav, footer').length;

		return href && isExternalLink(href) && !isExcluded && !isNavLink;
	});

	linksToUpdate.each(function () {
		const $link = $(this);

		console.info(`Processing href: ${$link.attr('href')}`);
		updateLinkParams($link, buildQueryParams($link.attr('href'), trackingParams));
	});
}

function init() {
	const trackingParams = config.ppcTrackingParams;

	updateTrackingLinks(trackingParams);
	tagManager.pushToDataLayer({ event: 'AffiliateLinksUpdated' });
}

export default {
	init
};
